export default {
    computed: {
        workSessionIsLoading() {
            return this.$workSessions.loading;
        },
        hasValidWorkSession() {
            return this.$workSessions.hasValidWorkSession
        },
        hasForceCloseWorkSessionFlag(){
            return (this.$workSessions.forceCloseWorkSession && this.hasValidWorkSession)? true : false
        },
        sessionExpired() {
            return !(this.timeLeftInSession > 0);
        },
        timeLeftInSession(){
            let tl = (this.sessionData) ? (( new Date(this.sessionData.ttl) - new Date()) /1000) : 0;
            return tl;
        },
        sessionData(){
            return this.$store.getters.getActiveWorkSession;
        },
    }
}